import React from "react";
import "../../css/MainPage/AboutUs.css";

import about1 from "../../assets/header-images/about1.jpg";
import LinkedInIconAboutUs from "../../assets/Icons/LinkedInIconAboutUs.png";

const TEAM = [
  {
    name: "F A",
    role: "Co-Founder",
    school: "Computer Science & Linguistics @ UCLA",
    // linkedin: "https://www.linkedin.com/in/fulati/",
    bio: "Passionate about making higher education accessible to all students through innovative technology solutions.",
  },
  {
    name: "Will Garcia",
    role: "Co-Founder",
    school: "Applied Math and Data Science @ UC Berkeley",
    linkedin: "https://www.linkedin.com/in/wgarcia25/",
    bio: "Dedicated to leveraging data science and mathematics to optimize student success pathways.",
  },
  {
    name: "Ricardo Varela Tellez",
    role: "Product Manager",
    school: "Computer Science & Linguistics @ UCLA",
    linkedin: "https://www.linkedin.com/in/ricardovarelatellez/",
    bio: "Focused on creating user-centered products that empower students in their educational journey.",
  },
  {
    name: "Khashayar Moradpour",
    role: "Software Engineer",
    school: "Computer Science @ SJSU",
    linkedin: "https://www.linkedin.com/in/kmoradpour/",
    bio: "Focused on creating user-centered products that empower students in their educational journey.",
  },
];

const COMPANY_VALUES = [
  {
    title: "Accessibility",
    description:
      "Making higher education guidance available to every student, regardless of background or circumstances.",
    icon: "🌍",
  },
  {
    title: "Excellence",
    description:
      "Providing the highest quality resources and support to ensure student success.",
    icon: "⭐",
  },
  {
    title: "Innovation",
    description:
      "Continuously evolving our platform with cutting-edge tools and methodologies.",
    icon: "💡",
  },
  {
    title: "Community",
    description:
      "Building a supportive network where students can connect, learn, and grow together.",
    icon: "🤝",
  },
];

const TIMELINE_EVENTS = [
  {
    year: "2023",
    title: "Foundation",
    description:
    "CollegeNav began as an idea to support transfer and first-gen students navigating higher education.",
  },
  {
    year: "2024",
    title: "Platform Launch",
    description:
      "Launched our comprehensive platform with scholarship search and college prep tools.",
  },
  {
    year: "2024",
    title: "Community Growth",
    description:
      "Reached 100+ students helped with college applications and scholarship searches.",
  },
  {
    year: "2025",
    title: "Future Vision",
    description:
      "Expanding to serve international students and partner with educational institutions.",
  },
];

const STATISTICS = [
  { number: "100+", label: "Students Helped" },
  { number: "$2M+", label: "Scholarships Found" },
  { number: "200+", label: "Resources Available" },
];

function AboutUs() {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <section
        className="main-landing-hero"
        style={{ backgroundImage: `url(${about1})` }}
      >
        <div className="main-landing-hero-overlay"></div>
        <div className="main-landing-hero-content">
          <h1>About CollegeNav</h1>
          <p className="main-landing-hero-sub">
            Empowering students to achieve their college dreams with expert
            guidance, comprehensive resources, and unwavering support.
          </p>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="aboutus-stats-section">
        <div className="aboutus-stats-container">
          <div className="aboutus-stats-grid">
            {STATISTICS.map((stat, index) => (
              <div className="aboutus-stat-card" key={index}>
                <div className="aboutus-stat-number">{stat.number}</div>
                <div className="aboutus-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="aboutus-mission-section">
        <div className="aboutus-mission-accent" />
        <div className="aboutus-mission-container">
          <div className="aboutus-mission-subheadline">Our Mission</div>
          <h2>Transforming College Dreams into Reality</h2>
          <p>
            At CollegeNav, our mission is to{" "}
            <span className="aboutus-mission-highlight">empower students</span>{" "}
            with the resources, knowledge, and support they need to confidently
            navigate the college application process. We are dedicated to
            helping each student achieve their academic dreams by providing{" "}
            <span className="aboutus-mission-highlight">
              personalized guidance and innovative tools
            </span>
            . Our goal is to make higher education accessible and attainable for
            all, ensuring every student can realize their full potential and
            build a brighter future.
          </p>
        </div>
      </section>

      {/* Company Values Section */}
      <section className="aboutus-values-section">
        <div className="aboutus-values-container">
          <h2 className="aboutus-values-title">Our Core Values</h2>
          <div className="aboutus-values-grid">
            {COMPANY_VALUES.map((value, index) => (
              <div className="aboutus-value-card" key={index}>
                <div className="aboutus-value-icon">{value.icon}</div>
                <h3 className="aboutus-value-title">{value.title}</h3>
                <p className="aboutus-value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="aboutus-timeline-section">
        <h2 className="aboutus-timeline-title">Our Journey</h2>
        <div className="aboutus-timeline-container">
          {TIMELINE_EVENTS.map((event, index) => (
            <div className="aboutus-timeline-item" key={index}>
              <div className="aboutus-timeline-dot"></div>
              <div className="aboutus-timeline-content">
                <div className="aboutus-timeline-year">{event.year}</div>
                <div className="aboutus-timeline-event">{event.title}</div>
                <div className="aboutus-timeline-desc">{event.description}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      <section className="aboutus-team-section">
        <h2 className="aboutus-team-title">Meet Our Team</h2>
        <p className="aboutus-team-subtitle">
          Passionate individuals dedicated to your educational success
        </p>
        <div className="aboutus-team-grid">
          {TEAM.map((member) => (
            <div className="aboutus-team-card" key={member.name}>
              <div className="aboutus-team-img-container">
                <div className="aboutus-team-img-placeholder">
                  {member.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
              </div>
              <div className="aboutus-team-info">
                <h3 className="aboutus-team-name">{member.name}</h3>
                <div className="aboutus-team-role">{member.role}</div>
                <div className="aboutus-team-school">{member.school}</div>
                <p className="aboutus-team-bio">{member.bio}</p>
                <a
                  className="aboutus-linkedin-btn"
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Connect on LinkedIn"
                >
                  <img
                    className="aboutus-linkedin-icon"
                    src={LinkedInIconAboutUs}
                    alt="LinkedIn"
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Vision Section */}
      <section className="aboutus-vision-section">
        <div className="aboutus-vision-container">
          <div className="aboutus-vision-content">
            <h2 className="aboutus-vision-title">Our Vision for the Future</h2>
            <p className="aboutus-vision-text">
              We envision a world where every student, regardless of their
              background, has equal access to quality higher education guidance
              and resources. Through continuous innovation and community
              building, we're working to eliminate barriers and create pathways
              to success for the next generation of leaders, innovators, and
              changemakers.
            </p>
            <div className="aboutus-vision-features">
              <div className="aboutus-vision-feature">
                <span className="aboutus-vision-feature-icon">🎯</span>
                <span>Personalized guidance for every student</span>
              </div>
              <div className="aboutus-vision-feature">
                <span className="aboutus-vision-feature-icon">🌐</span>
                <span>Global accessibility and reach</span>
              </div>
              <div className="aboutus-vision-feature">
                <span className="aboutus-vision-feature-icon">🚀</span>
                <span>Innovative technology solutions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="aboutus-cta-section">
        <div className="aboutus-cta-container">
          <h2 className="aboutus-cta-title">Ready to Start Your Journey?</h2>
          <p className="aboutus-cta-text">
            Join thousands of students who have successfully navigated their
            college journey with CollegeNav.
          </p>
          <div className="aboutus-cta-buttons">
            <a href="/college-prep" className="aboutus-cta-btn primary">
              Get Started Today
            </a>
            <a href="/contact-us" className="aboutus-cta-btn secondary">
              Contact Our Team
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;


